import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { authService } from '@/services/auth.service';
const TOKEN_KEY = 'vilabs_cms_token';
const REFRESH_KEY = 'vilabs_cms_refresh';
const STAFF_KEY = 'vilabs_cms_staff';
export const useAuthStore = defineStore('auth', () => {
    const accessToken = ref(localStorage.getItem(TOKEN_KEY));
    const refreshToken = ref(localStorage.getItem(REFRESH_KEY));
    const staff = ref(localStorage.getItem(STAFF_KEY) ? JSON.parse(localStorage.getItem(STAFF_KEY)) : null);
    const loading = ref(false);
    const isAuthenticated = computed(() => !!accessToken.value && !!staff.value);
    const isAdmin = computed(() => staff.value?.role === 'admin');
    async function login(email, password) {
        loading.value = true;
        try {
            const res = await authService.login(email, password);
            accessToken.value = res.tokens.accessToken;
            refreshToken.value = res.tokens.refreshToken;
            staff.value = res.staff;
            localStorage.setItem(TOKEN_KEY, res.tokens.accessToken);
            localStorage.setItem(REFRESH_KEY, res.tokens.refreshToken);
            localStorage.setItem(STAFF_KEY, JSON.stringify(res.staff));
            return res;
        }
        finally {
            loading.value = false;
        }
    }
    async function fetchMe() {
        if (!accessToken.value)
            return null;
        try {
            const me = await authService.me();
            staff.value = me;
            localStorage.setItem(STAFF_KEY, JSON.stringify(me));
            return me;
        }
        catch {
            await logout();
            return null;
        }
    }
    async function logout() {
        accessToken.value = null;
        refreshToken.value = null;
        staff.value = null;
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(REFRESH_KEY);
        localStorage.removeItem(STAFF_KEY);
    }
    return {
        accessToken,
        refreshToken,
        staff,
        loading,
        isAuthenticated,
        isAdmin,
        login,
        fetchMe,
        logout,
    };
});
